import { useState, type ReactNode } from 'react';
import { api } from '../api.js';
import { Button, Card, ErrorBox } from '../ui.js';

export function Login({ configured, onSuccess }: {
  configured: boolean;
  onSuccess: () => void;
}): ReactNode {
  const [pin, setPin] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  const submit = (e: React.FormEvent): void => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    api
      .login(pin)
      .then(onSuccess)
      .catch(setError)
      .finally(() => setBusy(false));
  };

  return (
    <div className="flex min-h-dvh flex-col justify-center px-6">
      <Card>
        <h1 className="text-2xl font-semibold">Wardrobe</h1>
        <p className="mt-2 text-sm text-white/55">
          {configured
            ? 'PIN eingeben.'
            : 'Erster Start — wähle einen PIN. Er gilt ab sofort für dieses Gerät und alle weiteren.'}
        </p>
        <form onSubmit={submit} className="mt-5 space-y-4">
          <input
            type="password"
            inputMode="numeric"
            autoComplete="current-password"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            placeholder="PIN"
            className="w-full rounded-xl bg-white/6 px-4 py-3 text-lg tracking-widest ring-1 ring-white/10 outline-none focus:ring-sky-500"
          />
          <Button type="submit" disabled={pin.length < 4 || busy} className="w-full">
            {busy ? 'Moment …' : configured ? 'Anmelden' : 'PIN festlegen'}
          </Button>
        </form>
        <ErrorBox error={error} />
        <p className="mt-6 text-xs text-white/45">
          Die eigentliche Absicherung ist Tailscale — der PIN schützt nur davor, dass ein
          fremdes Gerät im selben Tailnet einfach mitliest.
        </p>
      </Card>
    </div>
  );
}
